import i18n from 'helpers/i18n';
import messages from './messages';
import { ScoresByCycleTableView } from './ScoresByCycleTable';
import { CycleColumn, DomainGroup } from './utils';

interface DimensionRangesTableProps {
  /** A single domain, holding just the dimension(s) this feedback item covers. */
  domainGroup: DomainGroup;
  cycles: CycleColumn[];
  isInformal: boolean;
}

/**
 * Compact cycle-scores table for a single Observation Feedback accordion
 * item -- one dimension, or one domain's in-focus dimensions. Reuses
 * `ScoresByCycleTableView` so behavior matches the Summary page exactly.
 */
export function DimensionRangesTable({
  domainGroup,
  cycles,
  isInformal
}: DimensionRangesTableProps) {
  return (
    <div>
      <h3 className="pb-2 font-inter text-ds-xs font-medium text-ds-text-secondary">
        {i18n.ft(isInformal ? messages.rangesTitle : messages.scoresTitle)}
      </h3>

      <ScoresByCycleTableView
        domains={[domainGroup]}
        cycles={cycles}
        isInformal={isInformal}
        showControls={false}
        showDomainHeaders={false}
        compact
      />
    </div>
  );
}
